/**
 * Runtime config for the data layer (PLAN.md M7).
 *
 * The web app runs the engine CLIENT-SIDE for the MVP (instant, OFFLINE, dogfoodable with no
 * backend). Persistence has two modes, chosen by whether an API base URL is configured:
 *   - API base URL PRESENT → use the Hono RPC client (`hc<AppType>`) for server persistence and
 *     (future) large runs.
 *   - ABSENT → persist plans to localStorage (the offline fallback).
 *
 * The base URL comes from the Vite env var `VITE_API_BASE_URL` (set at build/dev time; empty by
 * default so the app is fully offline out of the box).
 */

/** The configured API base URL, or `null` when none is set (→ localStorage persistence). */
export function getApiBaseUrl(): string | null {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed.replace(/\/+$/, '') : null;
}

/** True when the app should talk to the API for persistence; false → localStorage. */
export function isApiConfigured(): boolean {
  return getApiBaseUrl() !== null;
}

/** localStorage namespace for the offline plan store. */
export const LOCAL_STORAGE_PLANS_KEY = 'projection.plans.v1';

/** Default Monte Carlo run parameters surfaced as the simulate form's initial values. */
export const DEFAULT_RUN = {
  sampler: 'iidMultiAsset' as const,
  nPaths: 1000,
  seed: 0,
  taxPolicy: 'none' as const,
};
